import { render, staticRenderFns } from "./MainUploader.vue?vue&type=template&id=c87ad8ee&scoped=true"
import script from "./MainUploader.vue?vue&type=script&lang=js"
export * from "./MainUploader.vue?vue&type=script&lang=js"
import style0 from "./MainUploader.vue?vue&type=style&index=0&id=c87ad8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87ad8ee",
  null
  
)

export default component.exports